/**
 * A status pill.
 *
 * The children are the label, and there is no variant without one. PRD §9.7
 * requires that status is never carried by colour alone, and the reliable way
 * to enforce that is to make the text structural rather than optional.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 5.6, PRD §9.7
 */
import { cn } from '../../lib/cn';

import { BADGE_TONES, type BadgeTone } from './badge-tones';

export interface BadgeProps {
  tone?: BadgeTone;
  /** The label. Required — see the note above. */
  children: React.ReactNode;
  className?: string;
}

/** Shape and type, copied from the reference prototype's `.badge`. */
const BADGE_BASE =
  'inline-flex items-center gap-[5px] rounded-full px-[11px] py-1 ' +
  'font-display text-[10px] leading-[1.5] font-extrabold tracking-[0.1em] ' +
  'whitespace-nowrap uppercase';

export function Badge({
  tone = 'mute',
  children,
  className,
}: BadgeProps): React.JSX.Element {
  return <span className={cn(BADGE_BASE, BADGE_TONES[tone], className)}>{children}</span>;
}
